export default "__VITE_PUBLIC_ASSET__6bf5d1a0__"